var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    enableBackground: "new 0 0 16 16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_822_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_823_",
    fill: "#707070",
    d: "M15.339,3.646c-0.574-0.683-1.636-0.962-3.662-0.962H4.323 c-2.072,0-3.151,0.296-3.724,1.023c-0.558,0.709-0.558,1.754-0.558,3.2v2.755c0,2.801,0.663,4.223,4.282,4.223h7.354 c1.758,0,2.73-0.245,3.36-0.848c0.646-0.619,0.922-1.628,0.922-3.375V6.907C15.959,5.382,15.916,4.331,15.339,3.646z M10.261,8.665 l-3.34,1.744c-0.075,0.04-0.157,0.06-0.238,0.06c-0.092,0-0.184-0.025-0.265-0.074c-0.154-0.094-0.249-0.261-0.249-0.439V6.476 c0-0.18,0.094-0.346,0.248-0.439C6.57,5.943,6.76,5.938,6.92,6.02l3.339,1.735c0.17,0.088,0.276,0.264,0.276,0.455 C10.535,8.4,10.43,8.576,10.261,8.665z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.a5d27e1048051247782b69e999128ed6.svg";
export { ForwardRef as ReactComponent };